import { formatMoneyDisplay, formatSignedMoneyDisplay } from '../finance/financeMoney';

export const BALANCE_HINT_LABELS = Object.freeze({
  payable: '建議支付',
  receivable: '建議收取',
  settled: '已平衡',
});

export function balanceHintLabel(kind) {
  return BALANCE_HINT_LABELS[kind] || BALANCE_HINT_LABELS.settled;
}

/** @deprecated 相容別名；請改用 balanceHintLabel */
export const settlementSuggestionLabel = balanceHintLabel;
export const SETTLEMENT_SUGGESTION_LABELS = BALANCE_HINT_LABELS;

/**
 * 分攤餘額提示（僅供參考，非付款／代收代付）。
 * 元件檔名保留歷史命名；對外請以 CostBalanceHints 匯出。
 */
export default function CostBalanceHints({
  members = [],
  currency,
  memberLabel,
}) {
  if (!members.length) return null;
  const currencyCode = currency ? String(currency) : '';

  return (
    <section
      className="journey-cost-balance-hints"
      aria-labelledby="cost-balance-hints-title"
      data-testid="cost-balance-hints"
    >
      <h3 id="cost-balance-hints-title" className="journey-cost-balance-hints__title">
        結算建議（僅供參考）
      </h3>
      <p className="journey-cost-balance-hints__copy">
        以下建議協助成員自行結算，平台不會代收、代付或標記結算狀態。
      </p>
      <ul className="journey-cost-balance-hints__list">
        {members.map((row, index) => {
          const kind = row.balanceKind || 'settled';
          const label = balanceHintLabel(kind);
          const name = typeof memberLabel === 'function'
            ? memberLabel(row.memberId)
            : '旅伴';
          return (
            <li key={row.resultId || `hint-${index}`}>
              <div>
                <strong>{name}</strong>
                <p className={`journey-cost-balance-hints__kind is-${kind}`}>{label}</p>
              </div>
              <div>
                <strong>
                  {formatSignedMoneyDisplay(row.netAmount)}
                  {currencyCode || row.currencyCode
                    ? ` ${currencyCode || row.currencyCode}`
                    : ''}
                </strong>
                <p className="journey-cost-balance-hints__copy">
                  帳上記錄
                  {' '}
                  {formatMoneyDisplay(row.paidAmount)}
                  {' · 應分攤 '}
                  {formatMoneyDisplay(row.owedAmount)}
                </p>
              </div>
            </li>
          );
        })}
      </ul>
      <p className="journey-cost-balance-hints__deferred">
        外部結清標記尚未開放，目前僅顯示建議。
      </p>
    </section>
  );
}
